import { useOpMutation } from '../useOpMutation';

export const useActivateMfaCredential = () =>
  useOpMutation({
    apiEndpointName: 'activateMfaCredential',
    onSuccessMessage: 'Successfully added MFA device',
    queryKeysToInvalidate: [['listMfaCredentials']],
  });
